import { ItemV5 } from '@knowledge/common/components/ItemSelectV5/types';
import { toUpperCase } from 'utils/toLowerCase';
import { SupplementKnowledgeAnswer } from 'services/api/supplementKnowledge';
import { KnowledgeRouteParams } from '../spu/types';

export const sys2LangMap: Record<string, string> = {
  'ZH-CN': 'CN',
  'EN-US': 'EN',
  ID: 'ID',
  TH: 'TH',
  TL: 'PH',
  VI: 'VN',
  PT: 'PT',
  ES: 'ES',
};

export const getLangFromSys = (sysLang: General.SystemLanguage) => {
  const upperLang = toUpperCase(sysLang) as string;
  return sys2LangMap?.[upperLang];
};

export const getTranslateContent = (
  lang: General.SystemLanguage,
  translateMap?: Record<string, string>,
) => {
  const upperLang = toUpperCase(lang) as string;
  return translateMap?.[sys2LangMap?.[upperLang]];
};

export const formatSpuList = (items: ItemV5[]) => {
  return items.map((item) => ({
    spuId: item.itemId,
    region: item.region,
    platform: item.platform,
    skus: item.skuInfo.map((sku) => ({ skuId: sku.skuId })),
  }));
};

export const isExistAnswer = (answers: SupplementKnowledgeAnswer[]) => {
  if (answers.length === 0) return false;
  const textAnswer = answers.find((answer) => answer.msgType === 'TEXT');
  return !!textAnswer?.message;
};

export const getSourceFromRouteParams = (routeParams: KnowledgeRouteParams | null) => {
  switch (routeParams) {
    case KnowledgeRouteParams.SupplementKnowledgeBootstrap:
    case KnowledgeRouteParams.SupplementKnowledgeAICheckFailed:
    case KnowledgeRouteParams.SupplementKnowledgeManual:
    case KnowledgeRouteParams.SupplementKnowledgeManualPending:
      return 'CUSTOMER';
    default:
      return undefined;
  }
};

export const getReviewStatusFromRouteParams = (
  routeParams: KnowledgeRouteParams | undefined,
  aiCheckValue: boolean,
): SupplementKnowledge.ReviewStatus[] | undefined => {
  if (routeParams === KnowledgeRouteParams.SupplementKnowledgeBootstrap) {
    if (aiCheckValue) {
      return ['MANUAL_REVIEW_PASSED_ENABLE_KNOWLEDGE', 'AI_REVIEW_PASSED_ENABLE_KNOWLEDGE'];
    } else {
      return ['MANUAL_REVIEW_PASSED_ENABLE_KNOWLEDGE'];
    }
  } else if (routeParams === KnowledgeRouteParams.SupplementKnowledgeAICheckFailed) {
    return ['AI_REVIEW_FAILED'];
  } else if (routeParams === KnowledgeRouteParams.SupplementKnowledgeManual) {
    return ['MANUAL_PENDING', 'MANUAL_REVIEW_FAILED'];
  } else if (routeParams === KnowledgeRouteParams.SupplementKnowledgeManualPending) {
    return ['MANUAL_PENDING', 'MANUAL_REVIEW_FAILED', 'AI_REVIEW_FAILED'];
  }
  return undefined;
};
